import React, { FC, useState } from 'react';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import useScrollToSection from '@hooks/useScrollToSection';
import useTranslation from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { ROUTES } from '../../constants';
import ContentWrapper from '../../ui/Content/Content';
import {
    Transportation,
    TransportationDescription,
    TransportationHeader,
    TransportationHeaderIcon,
    TransportationHeaderTitle,
    TransportationOption,
    TransportationOptions,
} from './Faqs.elements';

const ABOUT_QUESTIONS = [
    { id: 1, question: 'about.faq.question1.title', answer: 'about.faq.question1.answer.question1' },
    { id: 2, question: 'about.faq.question2.title', answer: 'about.faq.question2.answer.question1' },
    { id: 3, question: 'about.faq.question3.title', answer: 'about.faq.question3.answer.question1' },
    { id: 4, question: 'about.faq.question4.title', answer: 'about.faq.question4.answer.question1' },
    { id: 5, question: 'about.faq.question5.title', answer: 'about.faq.question5.answer.question1' },
    { id: 6, question: 'about.faq.question6.title', answer: 'about.faq.question6.answer.question1' },
];

const SUBSCRIPTION_QUESTIONS = [
    { id: 1, question: 'subscription.question1.question', answer: 'subscription.question1.answer' },
    { id: 2, question: 'subscription.question2.question', answer: 'subscription.question2.answer' },
    { id: 3, question: 'subscription.question3.question', answer: 'subscription.question3.answer' },
    { id: 4, question: 'subscription.question4.question', answer: 'subscription.question4.answer' },
    { id: 5, question: 'subscription.question5.question', answer: 'subscription.question5.answer' },
    { id: 6, question: 'subscription.question6.question', answer: 'subscription.question6.answer' },
    { id: 7, question: 'subscription.question7.question', answer: 'subscription.question7.answer' },
    { id: 8, question: 'subscription.question8.question', answer: 'subscription.question8.answer' },
    { id: 9, question: 'subscription.question9.question', answer: 'subscription.question9.answer' },
    { id: 10, question: 'subscription.question10.question', answer: 'subscription.question10.answer' },
];

interface FaqsProps {}

const DEFAULT_OPENED_KEY = 'ako-prebieha-online-skolenie';

const FaqsTemplate: FC<FaqsProps> = () => {
    const { t } = useTranslation();

    const router = useRouter();

    const [openedAreas, setOpenedAreas] = useState(
        router.asPath.includes(DEFAULT_OPENED_KEY) ? [ABOUT_QUESTIONS[0]?.id] : []
    );

    useScrollToSection(DEFAULT_OPENED_KEY, DEFAULT_OPENED_KEY, 250);

    const toggleTransportationOption = (option: number) => {
        if (openedAreas.includes(option)) {
            setOpenedAreas([]);
        } else {
            setOpenedAreas([]);
            setTimeout(() => {
                window.scrollTo({
                    top: document.getElementById(`${option}`).offsetTop - 150,
                    behavior: 'smooth',
                });
                setOpenedAreas([option]);
            }, 50);
        }
    };

    useScrollToSection('faqs', 'faqsId');

    return (
        <ContentWrapper mobileSidePadding={20} id="faqsId">
            <Transportation>
                <Title tagType={TitleTagTypes.H3} alignLeft isBlack>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t(
                                router.pathname.includes(ROUTES.SUBSCRIPTION)
                                    ? 'subscription.faq.title'
                                    : 'about.faq.title'
                            ),
                        }}
                    />
                </Title>
                <TransportationOptions>
                    {(router.pathname.includes(ROUTES.ABOUT_US) ? ABOUT_QUESTIONS : SUBSCRIPTION_QUESTIONS).map(
                        (area, key) => (
                            <TransportationOption key={key}>
                                <TransportationHeader id={`${area.id}`} onClick={() => toggleTransportationOption(area.id)}>
                                    <TransportationHeaderTitle
                                        className={openedAreas.includes(area.id) ? 'isOpen' : 'isClose'}
                                    >
                                        {t(area.question)}
                                    </TransportationHeaderTitle>
                                    <TransportationHeaderIcon
                                        className={openedAreas.includes(area.id) ? 'isOpen' : 'isClose'}
                                        name={Icons.ArrowDown}
                                    />
                                </TransportationHeader>
                                {openedAreas.includes(area.id) && (
                                    <TransportationDescription>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: t(area.answer),
                                            }}
                                        />
                                    </TransportationDescription>
                                )}
                            </TransportationOption>
                        )
                    )}
                </TransportationOptions>
            </Transportation>
        </ContentWrapper>
    );
};
export default FaqsTemplate;
